function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1952(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10.2,
    height: 1.51,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.25166666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 0.755
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.51,
    width: 10.2,
    height: 10.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 6.74
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.98,
    width: 10.2,
    height: 13.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 18.86
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.73,
    width: 10.2,
    height: 26.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 39.09
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.45,
    width: 10.2,
    height: 30.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 67.56
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.68,
    width: 10.2,
    height: 38.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 101.995
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 121.3,
    width: 10.2,
    height: 41.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 142.135
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.97,
    width: 10.2,
    height: 41.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 183.91
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.85,
    width: 10.2,
    height: 42.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 226.095
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 247.34,
    width: 10.2,
    height: 45.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 270.05
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.75,
    width: 10.2,
    height: 49.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 317.695
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 342.64,
    width: 10.2,
    height: 51.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 368.385
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 394.14,
    width: 10.2,
    height: 55.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 421.955
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.77,
    width: 10.2,
    height: 58.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 478.865
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.96,
    width: 10.2,
    height: 61.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 538.75
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 569.54,
    width: 10.2,
    height: 62.18,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 600.63
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 631.72,
    width: 10.2,
    height: 68.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.1,
    y: 665.86
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 0,
    width: 20.54,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.282222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.47,
    y: 19.195
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.74,
    y: 0,
    width: 21.33,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5549999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.405,
    y: 19.195
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.07,
    y: 0,
    width: 23.09,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.615,
    y: 19.195
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.16,
    y: 0,
    width: 25.04,
    height: 38.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.173333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.67999999999999,
    y: 19.195
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.2,
    y: 0,
    width: 25.44,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.92,
    y: 19.195
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.64,
    y: 0,
    width: 30.2,
    height: 38.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.033333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.74,
    y: 19.195
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.84,
    y: 0,
    width: 37.44,
    height: 38.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4879999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.56,
    y: 19.195
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.29,
    y: 0,
    width: 37.48,
    height: 38.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.03,
    y: 19.195
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.76,
    y: 0,
    width: 42.13,
    height: 38.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.825,
    y: 19.195
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.89,
    y: 0,
    width: 42.47,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.125,
    y: 19.195
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.36,
    y: 0,
    width: 42.65,
    height: 38.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.685,
    y: 19.195
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.01,
    y: 0,
    width: 42.77,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.265555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.395,
    y: 19.195
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.78,
    y: 0,
    width: 46.48,
    height: 38.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.02,
    y: 19.195
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.26,
    y: 0,
    width: 54.67,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.59499999999997,
    y: 19.195
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.94,
    y: 0,
    width: 60.62,
    height: 38.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.25,
    y: 19.195
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.55,
    y: 0,
    width: 64.76,
    height: 38.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5593333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.93,
    y: 19.195
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.31,
    y: 0,
    width: 72.69,
    height: 38.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.678
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.655,
    y: 19.195
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 38.39,
    width: 64.4,
    height: 47.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 62.03
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 85.67,
    width: 64.4,
    height: 51.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.168
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 111.51
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 137.35,
    width: 64.4,
    height: 65.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 169.91
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 202.47,
    width: 64.4,
    height: 66.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 235.57
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 268.67,
    width: 64.4,
    height: 66.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.200000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 301.97
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 335.28,
    width: 64.4,
    height: 68.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.953846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 369.34499999999997
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 403.4,
    width: 64.4,
    height: 69.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 438.24
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 473.08,
    width: 64.4,
    height: 75.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 510.59999999999997
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 548.12,
    width: 64.4,
    height: 75.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 585.69
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 623.26,
    width: 64.4,
    height: 76.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.400000000000006,
    y: 661.63
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 38.39,
    width: 81.75,
    height: 89.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.465,
    y: 82.955
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.34,
    y: 38.39,
    width: 83.91,
    height: 89.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.628181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.29500000000002,
    y: 82.955
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.25,
    y: 38.39,
    width: 86.8,
    height: 89.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.65,
    y: 82.955
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.05,
    y: 38.39,
    width: 114.86,
    height: 89.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.854999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.48,
    y: 82.955
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.91,
    y: 38.39,
    width: 118.6,
    height: 89.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.854999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.21000000000004,
    y: 82.955
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.51,
    y: 38.39,
    width: 139.49,
    height: 89.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.366428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.255,
    y: 82.955
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 127.52,
    width: 139.48,
    height: 90.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.32999999999998,
    y: 172.61
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 217.7,
    width: 139.48,
    height: 92.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7441666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.32999999999998,
    y: 264.16499999999996
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 310.63,
    width: 139.48,
    height: 95.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.602222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.32999999999998,
    y: 358.34
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 406.05,
    width: 139.48,
    height: 101.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.201818181818181
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.32999999999998,
    y: 456.66
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 507.27,
    width: 139.48,
    height: 192.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.497777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.32999999999998,
    y: 603.635
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.07,
    y: 127.52,
    width: 240.21,
    height: 143.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.006923076923076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.175,
    y: 199.065
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.28,
    y: 127.52,
    width: 245.72,
    height: 143.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.44142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.14,
    y: 199.065
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.07,
    y: 270.62,
    width: 485.93,
    height: 429.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.03454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.03499999999997,
    y: 485.31
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1952);
export default __webpack_public_path__ + "static/media/1952.07b0c057270c894b6514e3e5a129eb57.svg";
export { ForwardRef as ReactComponent };